// extracted by mini-css-extract-plugin
export var adjacentSlide = "_op-9";
export var arrowButtonContainer = "_op-5";
export var arrowButtonIcon = "_op-6";
export var carouselArrowButton = "_op-2";
export var carouselElementContainer = "_op-1";
export var currentSlide = "_op-8";
export var left = "_op-3";
export var otherSlide = "_op-a";
export var productCarouselContainer = "_op-0";
export var right = "_op-4";
export var sliderOverflow = "_op-7";